import cores from '../../helpers/partidos';
import store from '../../store';

function tmpCandidatos(e) {
  const { getState } = store;
  const { initial } = getState();
  const { list } = initial;
  const { NEWDATA } = list;
  const { candidatos } = NEWDATA;

  if (!e.candidatos) {
    return false;
  }
  const newArr = [
    ...e.candidatos.slice(0, 3),
  ];

  const listaCandidatos = arr => (
    arr.map(({ id_candidato, total_percentual, total_votos_validos }) => ( // eslint-disable-line
      `<div class="lista__candidatos__item">
        <span class="candidato__grupo">
          <span style="background-color: ${cores[candidatos[id_candidato].sigla_partido]}" class="candidato__grupo__partido"></span>
          <h3 class="candidato__grupo__nome">${candidatos[id_candidato].nome_candidato.toLowerCase()} (${candidatos[id_candidato].sigla_partido})</h3>
        </span>
        <span>${total_percentual}</span>
        <span>${total_votos_validos}</span>
      </div>`
    )).join('')
  );
  return (` 
    <div class="tooltip__container">
      <header class="tooltip__header">
        <h2>${e.municipio}</h2>
      </header>
      <div class="tooltip__body">
        <div class="lista__candidatos">
          <div class="lista__candidatos__topo">
            <span>Candidatos</span>
            <span>% do total</span>
            <span>Nº de votos</span>
          </div>
          <div class="lista__candidatos__dados">
            ${listaCandidatos(newArr)}
          </div>
        </div>
      </div>
      <footer class="tooltip__footer">
        <p></p>
      </footer>
    </div>
  `);
}

// TEMPLATE INDIVIDUAL
function tmpIndividual(e, currentKey) {
  const { getState } = store;
  const { initial } = getState();
  const { list } = initial;
  const { NEWDATA } = list;
  const { candidatos } = NEWDATA;
  const { param } = currentKey;
  if (!e.candidatos) {
    return false;
  }
  const candidatoData = e.candidatos.find(({ id_candidato }) => id_candidato === param);  // eslint-disable-line
  if (!candidatoData) return '';
  return (` 
    <div class="tooltip__container">
      <header class="tooltip__header">
        <h2>${e.municipio}</h2>
      </header>
      <div class="tooltip__body">
        <div class="lista__candidatos">
          <div class="lista__candidatos__topo">
            <span>Candidatos</span>
            <span>% do total</span>
            <span>Nº de votos</span>
          </div>
          <div class="lista__candidatos__dados">
            <div class="lista__candidatos__item">
            <span class="candidato__grupo">
              <span style="background-color: ${cores[candidatos[param].sigla_partido]}" class="candidato__grupo__partido"></span>
              <h3 class="candidato__grupo__nome">${candidatos[param].nome_candidato.toLowerCase()} (${candidatos[param].sigla_partido})</h3>
            </span>
            <span>${candidatoData.total_percentual}</span>
            <span>${candidatoData.total_votos_validos}</span>
          </div>
          </div>
        </div>
      </div>
      <footer class="tooltip__footer">
        <p></p>
      </footer>
    </div>
  `);
}

export {
  tmpCandidatos as candidatos,
  tmpIndividual as individual,
};



// WEBPACK FOOTER //
// ./src/components/mapa/tooltip.js